import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import config from "../../contexts/config";
import FloatingChatButton from "../floatingchat/FloatingChat";

import "../solar/solar-model.scss";
import CompanyContact from "../companycontact/CompanyContact";

const NyugdijasPromocioModel = () => {
  const chatButton = useRef();
  const [blogData, setBlogData] = useState({});
  const { id } = useParams();

  useEffect(() => {
    fetch(`${config.API_URL_ONRENDER}/blog/` + id)
      .then((res) => res.json())
      .then((data) => {
        setBlogData(data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, [id]);

  return (
    <>
      <div className="solar">
        <div className="solar__hero fade-bottom">
          <img
            src={require(`../../assets/solar/promocio.jpg`)}
            className="full-imagee"
            alt="hero"></img>
          <div
            className="solar__hero__info"
            style={{ color: "#fff", zIndex: 1, marginTop: "40dvh" }}>
            <motion.h1
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1 }}>
              Nyugdíjasok figyelem! Napelemes rendszer féláron!
            </motion.h1>
            <motion.h2
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1 }}>
              A vidéki nyugdíjasok 3 millió forint vissza nem térítendő
              támogatásban részesülhetnek!
            </motion.h2>
            <motion.h2
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1 }}>
              50%-os támogatás napelemek telepítésére!
            </motion.h2>
          </div>
        </div>

        <div
          className="solar__section__specs"
          style={{
            marginBottom: "150px",
            backgroundColor: "white",
            color: "black",
          }}>
          <div
            className="solar__section__specs__div"
            style={{ flexWrap: "wrap" }}>
            <div className="solar__section__specs__div__main">
              <motion.p
                style={{ marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                Örömmel tájékoztatjuk ügyfeleinket, hogy a kormány döntése
                értelmében kibővült a Vidéki Otthonfelújítási Program, így már a
                nyugdíjasok is jogosultak{" "}
                <strong>
                  a vissza nem térítendő otthonfelújítási támogatás és
                  otthonfelújítási kölcsön
                </strong>{" "}
                igénybevételére az 5000 fő alatti településeken.
              </motion.p>
              <motion.h3
                style={{
                  marginBottom: "12px",
                  marginTop: "24px",
                }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                Kik jogosultak a támogatásra?
              </motion.h3>
              <motion.ul
                style={{ marginBottom: "12px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                <li style={{ marginBottom: "12px", listStyleType: "disc" }}>
                  <strong>Nyugdíjasok,</strong> akik öregségi nyugdíjban vagy
                  korhatár előtti ellátásban részesülnek.
                </li>
                <li style={{ marginBottom: "12px", listStyleType: "disc" }}>
                  <strong>Lakóhely: </strong>
                  Az 5000 fő alatti településeken saját tulajdonú ingatlanban
                  élők.
                </li>
                <li style={{ marginBottom: "12px", listStyleType: "disc" }}>
                  <strong>Tulajdonjog: </strong>
                  Az igénylőnek legalább 50% tulajdonrésszel kell rendelkeznie
                  az érintett ingatlanban.
                </li>
                <li style={{ marginBottom: "12px", listStyleType: "disc" }}>
                  <strong>Köztartozás mentesség: </strong>
                  Az igénylőnek nem lehet 5000 forintot meghaladó köztartozása,
                  vagy azt 14 napon belül rendeznie kell.
                </li>
                <li style={{ marginBottom: "12px", listStyleType: "disc" }}>
                  <strong>Bentlakási kötelezettség: </strong>
                  Az igénylés után legalább 5 évig az érintett ingatlanban kell
                  laknia.
                </li>
              </motion.ul>
              <motion.h3
                style={{
                  marginBottom: "12px",
                  marginTop: "24px",
                }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                A támogatás főbb jellemzői:
              </motion.h3>
              <motion.ul
                style={{ marginBottom: "12px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                <li style={{ marginBottom: "12px", listStyleType: "disc" }}>
                  <strong>Támogatás mértéke: </strong>A felújítási költségek
                  50%-a, de legfeljebb 3 millió forint. Ez azt jelenti, hogy
                  akár 6 millió forintos beruházás esetén is igényelhető a
                  maximális támogatás.
                </li>
                <li style={{ marginBottom: "12px", listStyleType: "disc" }}>
                  <strong>Lakóhely: </strong>
                  Az 5000 fő alatti településeken saját tulajdonú ingatlanban
                  élők.
                </li>
                <li style={{ marginBottom: "12px", listStyleType: "disc" }}>
                  <strong>Kedvezményes hitellehetőség: </strong>
                  Az önerő biztosításához legfeljebb 6 millió forintos
                  kamattámogatott hitel is igényelhető, amely megkönnyíti a
                  projekt finanszírozását.
                </li>
              </motion.ul>
              <motion.p
                style={{ marginBottom: "24px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                Amennyiben szeretné kihasználni ezt a rendkívüli lehetőséget, és
                <strong>
                  féláron szeretne napelemes rendszerhez jutni,
                </strong>{" "}
                kérjük vegye fel velünk a kapcsolatot elérhetőségeink egyikén.
                Szakértő csapatunk készséggel áll rendelkezésére a tervezéstől a
                kivitelezésig, hogy otthona energiatakarékosabb és
                fenntarthatóbb legyen.
              </motion.p>
              <motion.h2
                style={{
                  marginBottom: "12px",
                  marginTop: "48px",
                }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                Magyar közlöny 25. szám
              </motion.h2>
              <motion.p
                style={{ marginBottom: "24px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                2. A Vidéki Otthonfelújítási Programról szóló 389/2024. (XII.
                11.) Korm. rendelet módosítása 2. § A Vidéki Otthonfelújítási
                Programról szóló 389/2024. (XII. 11.) Korm. rendelet (a
                továbbiakban: Rendelet) 3. § (1) bekezdése helyébe a következő
                rendelkezés lép: „(1) A támogatást a) a legalább egy gyermeket
                váró vagy nevelő igénylő vagy b) a társadalombiztosítási
                nyugellátásról szóló törvény szerinti öregségi nyugdíjban vagy –
                a rá irányadó nyugdíjkorhatár betöltését követően – özvegyi
                nyugdíjban, a megváltozott munkaképességű személyek ellátásairól
                és egyéb törvények módosításáról szóló törvény szerint – a rá
                irányadó nyugdíjkorhatár betöltését követően – rokkantsági vagy
                rehabilitációs ellátásban, illetve korhatár előtti ellátásban,
                szolgálati járandóságban, átmeneti bányászjáradékban,
                táncművészeti életjáradékban, a Magyar Alkotóművészeti
                Közalapítvány által folyósított ellátásokról szóló
                kormányrendelet alapján folyósított öregségi, rokkantsági
                nyugdíjsegélyben (nyugdíjban), egyházi jogi személytől
                nyugdíjban vagy öregségi, munkaképtelenségi járadékban részesülő
                igénylő, ideértve azt is, akinek esetében a folyósítást
                szüneteltetik, – azonos lakóhellyel rendelkező házastársak vagy
                élettársak közösen, együttes igénylőként – az 1. mellékletben
                szereplő településen lévő lakás vonatkozásában igényelheti.”
              </motion.p>
              <motion.h3
                style={{
                  marginBottom: "12px",
                  marginTop: "24px",
                }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                Összegezve
              </motion.h3>
              <motion.p
                style={{ marginBottom: "12px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                A Vidéki Otthonfelújítási Program 2025. március 27-től kiterjed
                a nyugdíjasokra is, akik az alábbi feltételek teljesülése esetén
                igényelhetik a támogatást:
              </motion.p>
              <motion.ul
                style={{ marginBottom: "12px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                <strong>Ellátás típusa:</strong>
                <li
                  style={{
                    marginBottom: "12px",
                    marginTop: "12px",
                    listStyleType: "disc",
                  }}>
                  Öregségi nyugdíj
                </li>
                <li
                  style={{
                    marginBottom: "12px",
                    listStyleType: "disc",
                  }}>
                  Özvegyi nyugdíj (a nyugdíjkorhatár betöltése után)
                </li>
                <li
                  style={{
                    marginBottom: "12px",
                    listStyleType: "disc",
                  }}>
                  Rokkantsági vagy rehabilitációs ellátás (a nyugdíjkorhatár
                  betöltése után)
                </li>
                <li
                  style={{
                    marginBottom: "12px",
                    listStyleType: "disc",
                  }}>
                  Korhatár előtti ellátás
                </li>
                <li
                  style={{
                    marginBottom: "12px",
                    listStyleType: "disc",
                  }}>
                  Szolgálati járandóság
                </li>
                <li
                  style={{
                    marginBottom: "12px",
                    listStyleType: "disc",
                  }}>
                  Átmeneti bányászjáradék
                </li>
                <li
                  style={{
                    marginBottom: "12px",
                    listStyleType: "disc",
                  }}>
                  Táncművészeti életjáradék
                </li>
                <li
                  style={{
                    marginBottom: "24px",
                    listStyleType: "disc",
                  }}>
                  Egyházi jogi személytől kapott nyugdíj vagy munkaképtelenségi
                  járadék
                </li>
              </motion.ul>
              <motion.p
                style={{ marginBottom: "12px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                <strong>Lakóhely: </strong>Az ingatlannak preferált
                kistelepülésen kell lennie, azaz olyan településen, ahol a
                lakosság száma nem haladja meg az 5000 főt. Tulajdonjog: Az
                igénylőnek legalább 50%-os tulajdoni hányaddal kell rendelkeznie
                a felújítandó ingatlanban.
              </motion.p>
              <motion.p
                style={{ marginBottom: "12px", marginTop: "12px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                <strong>Lakcím: </strong>Az igénylőnek állandó lakcímmel kell
                rendelkeznie a felújítandó ingatlanban.
              </motion.p>
              <motion.p
                style={{ marginBottom: "12px", marginTop: "12px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                <strong>Köztartozás-mentesség: </strong>Az igénylőnek nem lehet
                5000 forintot meghaladó adó- vagy egyéb köztartozása.
              </motion.p>
              <motion.p
                style={{ marginBottom: "12px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                Fontos megjegyezni, hogy a nyugdíjas igénylők esetében nem
                szükséges 25 év alatti gyermeket nevelniük, és a legalább
                egyéves társadalombiztosítási (TB) jogviszony sem feltétel.
              </motion.p>
              <motion.p
                style={{ marginBottom: "12px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                A támogatás összege legfeljebb 3 millió forint vissza nem
                térítendő támogatás, valamint maximum 6 millió forint
                kedvezményes kamatozású hitel igényelhető.
              </motion.p>
              <motion.p
                style={{ marginBottom: "12px", marginTop: "24px" }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}>
                A támogatási kérelmeket a Magyar Államkincstárhoz lehet
                benyújtani elektronikusan, személyesen vagy postai úton.
              </motion.p>
              <motion.img
                style={{
                  marginTop: "48px",
                  marginRight: "auto",
                  marginLeft: "auto",
                  maxWidth: "500px",
                  width: "100%",
                }}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}
                src={require(`../../assets/discount/nyugdijas.jpg`)}
                alt="hero"></motion.img>
            </div>
          </div>
        </div>

        <CompanyContact
          onCallback={() => chatButton.current.openChat()}
        />
      </div>
      <FloatingChatButton ref={chatButton} />
    </>
  );
};

export default NyugdijasPromocioModel;
